"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2548,3117],{

/***/ 53117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pop_up_base; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 23 modules
var dialog = __webpack_require__(65518);
// EXTERNAL MODULE: ./public/assets/icons/ExitPopUp.svg
var ExitPopUp = __webpack_require__(61740);
;// CONCATENATED MODULE: ./components/atoms/pop-up-base/PopUpBase.tsx



/**
 * PopUpBase
 */ var PopUpBase = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, state = param.state, children = param.children, funcionOnClose = param.funcionOnClose, thumbsChildren = param.thumbsChildren, desc = param.desc, title = param.title, _type = param.type, type = _type === void 0 ? "base" : _type, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? "#fff" : _bgColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
        open: state,
        onClose: funcionOnClose,
        className: "fixed inset-0 z-50 grid place-items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Overlay */.V.Overlay, {
                className: "fixed inset-0 bg-[rgba(21,33,39,0.7)]",
                onClick: funcionOnClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Panel */.V.Panel, {
                className: "z-50 flex flex-col items-center overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex h-full flex-col items-center justify-around gap-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                backgroundColor: "".concat(bgColor, " !important")
                            },
                            className: "flex flex-col rounded-md text-primary-400 sm:justify-around ".concat(type === "galery" ? "bg-transparent sm:bg-white" : "", " h-fit w-full max-w-[calc(100vw-2rem)] p-4 sm:h-auto sm:w-auto sm:p-5 ").concat(className),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-2 flex flex-row justify-between gap-4 sm:mb-2 sm:mt-0 ".concat(type === "galery" ? "my-5" : "my-2"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col gap-1",
                                            children: [
                                                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "text-heading text-heading--h3",
                                                    children: title
                                                }),
                                                desc && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-body text-body--secondary--bold",
                                                    children: desc
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitPopUp["default"], {
                                            heigth: 32,
                                            width: 32,
                                            className: "flex-shrink-0 hover:cursor-pointer",
                                            onClick: funcionOnClose
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: type === "galery" ? "min-h-[60vh] min-w-[80vw]" : type === "iframe" ? desc ? "relative h-[calc(100vh-68px)] min-w-[100vw] sm:h-[60vh] sm:min-w-[80vw]" : "relative h-[calc(100vh-48px)] min-w-[100vw] sm:h-[60vh] sm:min-w-[80vw]" : "h-[60vh] overflow-y-auto sm:h-auto sm:w-auto",
                                    children: children
                                })
                            ]
                        }),
                        thumbsChildren && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-3 min-h-fit sm:mb-0",
                            children: thumbsChildren
                        })
                    ]
                })
            })
        ]
    });
};
PopUpBase.displayName = "PopUpBase";

;// CONCATENATED MODULE: ./components/atoms/pop-up-base/index.ts

/* harmony default export */ var pop_up_base = (PopUpBase);


/***/ }),

/***/ 74637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ atoms_select; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(36045);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(74772);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(42667);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
;// CONCATENATED MODULE: ./components/atoms/select/Select.tsx








/**
 * Select
 */ var Select = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _elements = param.elements, elements = _elements === void 0 ? [] : _elements, name = param.name, defaultValue = param.defaultValue, label = param.label, requiredMessage = param.requiredMessage;
    var ref = (0,index_esm/* useFormContext */.Gc)(), register = ref.register, errors = ref.formState.errors, setValue = ref.setValue, trigger = ref.trigger;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var elemntIndex = elements.findIndex(function(elemt) {
        return (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value) === elemt.value.toString();
    });
    var selectValidation = function(value) {
        return value !== "-1" || "Please select a valid option";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: name,
                className: "text-other--label-form uppercase",
                children: [
                    label,
                    requiredMessage && " *"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                id: name
            }, register(name, (0,_object_spread/* default */.Z)({}, requiredMessage !== undefined ? {
                required: requiredMessage,
                validate: selectValidation
            } : {
                required: requiredMessage
            }))), {
                name: name,
                defaultValue: elemntIndex !== -1 ? defaultValue ? defaultValue.value : 0 : elemntIndex,
                className: "text-body ".concat(errors[name] ? "border-[#ff0000] text-[#ff0000] placeholder-[#ff0000]" : "text-body--primary border-primary-400 text-primary-400 placeholder-primary-400", "   w-full cursor-pointer border-b  bg-transparent pb-2  outline-none ").concat(className),
                onChange: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    setValue(name, e.target.value);
                                    return [
                                        4,
                                        trigger(name)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: [
                    defaultValue && elemntIndex === -1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: defaultValue.value,
                        children: defaultValue.label
                    }) : null,
                    elements === null || elements === void 0 ? void 0 : elements.map(function(child, index) {
                        return /*#__PURE__*/ (0,react.createElement)("option", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, child.disabled && {
                            disabled: true
                        }), {
                            className: "w-full",
                            key: index,
                            value: child.value,
                            children: [
                                child.label,
                                child.disabled ? t("components.atoms.select.soon") : ""
                            ]
                        }));
                    })
                ]
            })),
            errors[name] && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-other--detail text-[#ff0000]",
                children: errors[name].message
            })
        ]
    });
};
Select.displayName = "Select";

;// CONCATENATED MODULE: ./components/atoms/select/index.ts

/* harmony default export */ var atoms_select = (Select);


/***/ }),

/***/ 2548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ cross_template; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 1 modules
var container = __webpack_require__(82112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(60123);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(96052);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(46572);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/atoms/multimedia/index.ts + 1 modules
var atoms_multimedia = __webpack_require__(89381);
// EXTERNAL MODULE: ./components/atoms/caption/index.ts + 1 modules
var atoms_caption = __webpack_require__(38959);
// EXTERNAL MODULE: ./components/atoms/button/index.ts + 1 modules
var atoms_button = __webpack_require__(60825);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
// EXTERNAL MODULE: ./components/atoms/pop-up-base/index.ts + 1 modules
var pop_up_base = __webpack_require__(53117);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(42667);
// EXTERNAL MODULE: ./components/atoms/select/index.ts + 1 modules
var atoms_select = __webpack_require__(74637);
;// CONCATENATED MODULE: ./components/molecules/calendly-form/CalendlyForm.tsx
//eslint-disable-next-line
//@ts-nocheck









/**
 * CalendlyForm
 */ var CalendlyForm = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, cities = param.cities, buildings = param.buildings, provinces = param.provinces;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var _ref = (0,index_esm/* useForm */.cI)(), handleSubmit = _ref.handleSubmit, watch = _ref.watch, register = _ref.register, setValue = _ref.setValue, methods = (0,_object_without_properties/* default */.Z)(_ref, [
        "handleSubmit",
        "watch",
        "register",
        "setValue"
    ]);
    var mapOfCities = new Map(cities);
    var mapOfBuildings = new Map(buildings);
    var watchProvince = watch("provinces", provinces[0].value.toString());
    var watchBuildings = watch("buildings");
    var watchCities = watch("cities", mapOfCities.get(provinces[0].value.toString())[0].value);
    var ref = (0,react.useState)(mapOfCities.get(provinces[0].value.toString())), citiesSelect = ref[0], setCitiesSelect = ref[1];
    var ref1 = (0,react.useState)(mapOfBuildings.get(watchCities)), buildingsSelect = ref1[0], setBuildingsSelect = ref1[1];
    var ref2 = (0,react.useState)(), buttonActive = ref2[0], setButtonActive = ref2[1];
    // Esta funcion tiene encuenta la provincia selecccionada.
    // Despues establezco el valor de las ciudades para
    // tener el primer objecto de las lista seleccionado
    (0,react.useEffect)(function() {
        setCitiesSelect(mapOfCities.get(watchProvince));
        setValue("cities", mapOfCities.get(watchProvince)[0].value);
    }, [
        watchProvince
    ]);
    (0,react.useEffect)(function() {
        var ref;
        setValue("save", (ref = buildingsSelect === null || buildingsSelect === void 0 ? void 0 : buildingsSelect.find(function(build) {
            return build.value === watchBuildings;
        })) === null || ref === void 0 ? void 0 : ref.value);
    }, [
        watchBuildings
    ]);
    // Los dos useEffect siguentes me establecen los edificios a seleccionar.
    // Este primero tiene encuenta si se ha cambiado la lista de ciudades
    // si es asi mira cual a sido seleccionada y despues me guarda el valor.
    (0,react.useEffect)(function() {
        setBuildingsSelect(mapOfBuildings.get(watchCities));
        // Me Guardo esta valor para el submmit
        // Si lo guardo como buildings da problemas
        setButtonActive(mapOfBuildings.get(watchCities)[0].disabled);
        setValue("save", mapOfBuildings.get(watchCities)[0].value);
    }, [
        watchCities
    ]);
    // Este tiene encuenta si la lista de las ciudades a cambiado, que
    // es lo mismo que decir que se ha cambiado la provincia
    // por eso se mira la provincia seccionada y cojo el primer valor seleccionado.
    // depsues cojo el valor del primera ciudad y establezco los edificios
    (0,react.useEffect)(function() {
        setBuildingsSelect(mapOfBuildings.get(mapOfCities.get(watchProvince)[0].value));
        setButtonActive(mapOfBuildings.get(mapOfCities.get(watchProvince)[0].value)[0].disabled);
        // Me Guardo esta valor para el submmit
        // Si lo guardo como buildings da problemas
        setValue("save", mapOfBuildings.get(mapOfCities.get(watchProvince)[0].value)[0].value);
    }, [
        citiesSelect
    ]);
    var onSubmit = function(data) {
        var ref, ref1;
        var url = (ref1 = (ref = mapOfBuildings.get(data.cities)) === null || ref === void 0 ? void 0 : ref.find(function(temp) {
            return temp.value === data.save;
        })) === null || ref1 === void 0 ? void 0 : ref1.url;
        if (url) {
            window.open("".concat(url), "_blank", "noopener noreferrer");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute -top-[62%] left-[80%] hidden md:block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "u-aspect-square relative w-10 md:w-14",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/assets/domainBrand/logo-base.svg",
                        alt: "Logo BecasaEssentials",
                        "aria-label": "Logo BecasaEssentials",
                        objectFit: "contain",
                        layout: "fill"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                handleSubmit: handleSubmit,
                register: register,
                setValue: setValue,
                watch: watch
            }, methods), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    className: "flex flex-col gap-4",
                    onSubmit: handleSubmit(onSubmit),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_select/* default */.Z, {
                            label: t("components.molecules.calendlyForm.provinces"),
                            name: "provinces",
                            elements: provinces
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_select/* default */.Z, {
                            label: t("components.molecules.calendlyForm.cities"),
                            name: "cities",
                            elements: citiesSelect
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_select/* default */.Z, {
                            label: t("components.molecules.calendlyForm.buildings"),
                            name: "buildings",
                            elements: buildingsSelect
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                            type: "submit",
                            variant: "secondary",
                            size: "large",
                            className: "mt-4 w-full md:w-1/2",
                            disabled: buttonActive,
                            children: "Solicitar una visita"
                        })
                    ]
                })
            }))
        ]
    });
};
CalendlyForm.displayName = "CalendlyForm";

;// CONCATENATED MODULE: ./components/molecules/calendly-form/index.ts

/* harmony default export */ var calendly_form = (CalendlyForm);

;// CONCATENATED MODULE: ./components/organisms/pop-up-calendly/PopUpCalendly.tsx






/**
 * PopUpCalendly
 */ var PopUpCalendly = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, onClose = param.onClose, open = param.open, formProps = param.formProps;
    var t = (0,useTranslation/* default */.Z)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(pop_up_base["default"], {
        className: "".concat(className, " relative overflow-visible bg-surface-01  text-text-primary md:min-w-[500px]"),
        state: open,
        funcionOnClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-[10%] top-[7%] block md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "u-aspect-square relative w-10 md:w-14",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/assets/domainBrand/logo-base.svg",
                        alt: "Logo BecasaEssentials",
                        "aria-label": "Logo BecasaEssentials",
                        objectFit: "contain",
                        layout: "fill"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex max-w-[550px] flex-col gap-4 rounded-md bg-white p-8 shadow-md md:!mx-20 md:!my-7",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-subtitle--large",
                        children: t("components.organisms.popUpCalendly.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-body text-body--primary",
                        children: t("components.organisms.popUpCalendly.desc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(calendly_form, (0,_object_spread/* default */.Z)({}, formProps))
                ]
            })
        ]
    });
};
PopUpCalendly.displayName = "PopUpCalendly";

;// CONCATENATED MODULE: ./components/organisms/pop-up-calendly/index.ts

/* harmony default export */ var pop_up_calendly = (PopUpCalendly);

;// CONCATENATED MODULE: ./components/molecules/cross/Cross.tsx









var VARIANT_MAPS = {
    Derecha: "md:!flex-row-reverse",
    Izquierda: "md:!flex-row"
};
var VARIANT_TEXT_MAPS = {
    primary: "text-primary",
    primaryLight: "text-primary-light",
    secondary: "text-secondary",
    tertiary: "text-black",
    alternative: "text-white"
};
var PopUpBookingLavanda = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9501), __webpack_require__.e(735), __webpack_require__.e(6494)]).then(__webpack_require__.bind(__webpack_require__, 80735));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80735)
            ];
        }
    },
    ssr: false
});
/**
 * Cross
 */ var Cross = function(param) {
    var _id = param.id, id = _id === void 0 ? "" : _id, _className = param.className, className = _className === void 0 ? "" : _className, propsButton = param.propsButton, description = param.description, propsLink = param.propsLink, widerPart = param.widerPart, posicionText = param.posicionText, title = param.title, backgroundColor = param.backgroundColor, caption = param.caption, multimedia = param.multimedia, centerLogo = param.centerLogo, textColor = param.textColor, hasPopUp = param.hasPopUp, accommodationSelect = param.accommodationSelect, buildingSelect = param.buildingSelect, calendlyProps = param.calendlyProps, popUpTipe = param.popUpTipe, defaultApartment = param.defaultApartment, defaultBuilding = param.defaultBuilding, tipoMedio = param.tipoMedio, url = param.url, _noShadow = param.noShadow, noShadow = _noShadow === void 0 ? false : _noShadow;
    var ref = (0,react.useState)(false), formOpen = ref[0], setFormOpen = ref[1];
    var popUpToggle = function() {
        setFormOpen(!formOpen);
    };
    var ref1 = (0,react.useState)(false), calendlyOpen = ref1[0], setCalendlyOpen = ref1[1];
    var calendlyToggle = function() {
        setCalendlyOpen(!calendlyOpen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            hasPopUp && accommodationSelect && buildingSelect && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUpBookingLavanda, {
                apartmentsByBuilding: accommodationSelect,
                buildings: buildingSelect,
                show: formOpen,
                onClose: popUpToggle,
                defaultBuilding: defaultBuilding,
                defaultApartment: defaultApartment
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: id,
                className: "".concat(VARIANT_MAPS[posicionText], " cross-container ").concat(className),
                children: [
                    multimedia ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_multimedia/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, multimedia), {
                        imageAbove: undefined,
                        src: (multimedia === null || multimedia === void 0 ? void 0 : multimedia.src) ? multimedia.src : undefined,
                        className: "flex !h-[200px] md:hidden"
                    })) : null,
                    (multimedia === null || multimedia === void 0 ? void 0 : multimedia.imageAbove) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(centerLogo ? "absolute left-1/2 top-[105px] h-[75px] w-[75px] -translate-x-1/2 -translate-y-1/2 md:hidden" : "absolute left-4 top-[200px]  h-14 w-14 -translate-y-1/2 md:hidden"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            objectFit: "contain",
                            layout: "fill",
                            alt: "Logo Be Casa",
                            src: multimedia.imageAbove
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-full flex-col justify-between gap-5  rounded-b-md  px-6 pb-7 pt-10 shadow-none md:rounded-md md:py-8 ".concat(!noShadow ? "md:shadow-sm" : "", "  ").concat(widerPart === "Imagen" && posicionText === "Derecha" ? "md:w-[53%]" : widerPart === "ImagenXL" ? "md:w-[35%]" : "md:w-[73%]"),
                        style: {
                            backgroundColor: backgroundColor ? "var(--tw-color-".concat(backgroundColor, ")") : "#fff"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-4 ".concat(widerPart === "Imagen" && posicionText === "Derecha" ? "lg:px-1" : widerPart === "ImagenXL" ? "lg:px-1" : "lg:px-14", "  ").concat(VARIANT_TEXT_MAPS[textColor]),
                                children: [
                                    caption && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_caption/* default */.Z, {
                                        variant: textColor,
                                        children: caption
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "cross-title text-heading text-heading--h3",
                                        children: title
                                    }),
                                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-body text-body--primary",
                                        children: description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex w-full flex-col flex-wrap items-center gap-10 md:w-auto md:flex-row ".concat(widerPart === "Imagen" && posicionText === "Derecha" ? "mr-auto" : widerPart === "ImagenXL" ? "" : (propsButton === null || propsButton === void 0 ? void 0 : propsButton.src) && (propsLink === null || propsLink === void 0 ? void 0 : propsLink.src) ? "md:ml-14" : "ml-auto"),
                                children: [
                                    !hasPopUp ? (propsButton === null || propsButton === void 0 ? void 0 : propsButton.src) && (propsButton === null || propsButton === void 0 ? void 0 : propsButton.children) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: propsButton.src,
                                        "aria-label": "Solicitar Visita",
                                        passHref: true,
                                        prefetch: false,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            className: "text-links text-links--default w-full ".concat(widerPart === "ImagenXL" ? "w-full" : (propsButton === null || propsButton === void 0 ? void 0 : propsButton.src) && (propsLink === null || propsLink === void 0 ? void 0 : propsLink.src) ? "md:w-auto" : "md:!w-fity"),
                                            "aria-label": "Solicitar Visita"
                                        }, propsButton), {
                                            as: "a"
                                        }))
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                        className: "text-links text-links--default w-full ".concat(widerPart === "ImagenXL" ? "w-full" : (propsButton === null || propsButton === void 0 ? void 0 : propsButton.src) && (propsLink === null || propsLink === void 0 ? void 0 : propsLink.src) ? "md:w-auto" : "md:!w-fity"),
                                        onClick: popUpTipe === "Lavanda" ? popUpToggle : calendlyToggle,
                                        size: propsButton.size,
                                        variant: propsButton.variant,
                                        children: propsButton.children
                                    }),
                                    (propsLink === null || propsLink === void 0 ? void 0 : propsLink.src) && (propsLink === null || propsLink === void 0 ? void 0 : propsLink.label) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: propsLink.src,
                                        passHref: true,
                                        prefetch: false,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                                            className: "text-links text-links--default",
                                            variant: propsLink.variant,
                                            "aria-label": "Contactanos",
                                            arrow: true,
                                            children: propsLink.label
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_multimedia/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, multimedia), {
                        className: "hidden overflow-hidden shadow-none md:flex md:rounded-md md:shadow-sm ".concat(widerPart === "Imagen" ? "md:w-[73%]" : widerPart === "ImagenXL" ? "md:w-[65%]" : "md:w-[27%]"),
                        clickableImgSrc: tipoMedio === "url" ? url : ""
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pop_up_calendly, {
                    open: calendlyOpen,
                    onClose: calendlyToggle,
                    formProps: calendlyProps
                })
            })
        ]
    });
};
Cross.displayName = "Cross";

;// CONCATENATED MODULE: ./components/molecules/cross/index.ts

/* harmony default export */ var cross = (Cross);

;// CONCATENATED MODULE: ./components/templates/cross-template/CrossTemplate.tsx






/**
 * CrossTemplate
 */ var CrossTemplate = function(_param) {
    var crossProps = _param.crossProps, _cutLevel = _param.cutLevel, cutLevel = _cutLevel === void 0 ? 50 : _cutLevel, _cutLevelMobile = _param.cutLevelMobile, cutLevelMobile = _cutLevelMobile === void 0 ? 50 : _cutLevelMobile, config = (0,_object_without_properties/* default */.Z)(_param, [
        "crossProps",
        "cutLevel",
        "cutLevelMobile"
    ]);
    var hideShadow = !config.hasCutLevel && config.backgroundColorTop === crossProps.backgroundColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "py-6 lg:py-20",
        cutLevel: cutLevel === null ? 50 : cutLevel,
        cutLevelMobile: cutLevelMobile === null ? 50 : cutLevel
    }, config), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cross, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, crossProps), {
            noShadow: hideShadow
        }))
    }));
};
CrossTemplate.displayName = "CrossTemplate";

;// CONCATENATED MODULE: ./components/templates/cross-template/index.ts

/* harmony default export */ var cross_template = (CrossTemplate);


/***/ }),

/***/ 36045:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ })

}]);